import { gql } from '../../../__generated__/graphql/catalog'

export const CART_ATTRIBUTES_UPDATE = gql(`
  mutation CartAttributesUpdate($cartId: ID!, $attributes: [CustomAttributeInput]!) {
    cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
      cart {
        ...Cart
      }
      userErrors {
        code
        field
        message
      }
      warnings {
        code
        message
        target
      }
    }
  }
`)
